'use client'

import { useTranslation } from '@shared/config/i18n'
import { UI_IDS } from '@shared/constants'
import { useNavigateToHome } from '@shared/routes'
import { PageContent } from '@shared/ui'
import Image from 'next/image'
import React from 'react'

import { ButtonV1, Typography, VStack } from '@podo-app/design-system-temp'

const NotFound = () => {
  const navigateToHome = useNavigateToHome()
  const t = useTranslation()

  return (
    <VStack as={PageContent} className="h-dvh items-center justify-center m-auto gap-7">
      <Image src="/images/not-found.png" alt="Not Found" width={140} height={140} />
      <Typography size="body1" className="text-gray-400 text-center">
        {t('common.errors.notFoundLine1')} <br /> {t('common.errors.notFoundLine2')}
      </Typography>
      <ButtonV1
        onClick={() => navigateToHome({ preserveParams: true })}
        eventParams={{ name: UI_IDS.btn.goHome, location: 'error', action: 'navigate' }}
      >
        {t('navigation.bottom.home')}
      </ButtonV1>
    </VStack>
  )
}

export default NotFound
